module.exports = __webpack_public_path__ + "static/media/pizza.6da4fc13.jpg";